export default "__VITE_ASSET__CLs9Kpvl__"